module.exports = __webpack_public_path__ + "img/docAppointRes_c.1716ee55.png";